import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
  Typography,
} from "@mui/material";
//*files
import cssClasses from "./RepriceUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";

import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
//service

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import {
  checkForInventoryStatus,
  updateCancelRequests,
  updateCancelRequestsForLeadAcceptance,
  updateCancelRequestsForReprice,
  updateChangeRequestsForReprice,
  updateInventorForCancelUnit,
} from "../../Services/Event";
import { insertInventoryLogs } from "../../Services/AllAllotments";
import { checkForChangeUnitStatus } from "../../Services/AlotUnit";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));

export default function RepriceUnit({ open, handleClose, returnRes, data, selectedAllotmentPass, isRepriceForChangeUnit, isRepricePending }) {

  console.log("selectedAllotmentPass", selectedAllotmentPass)
  console.log("isCommercial", selectedAllotmentPass?.isCommercial);

  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [skipChangesValues, setSkipChangesValues] = useState(false)
  const [updateUnitPrice, setUpdateUnitPrice] = useState({
    bsp: 0,
    sdr: 0,
    gst: 0,
    total: 0,
  });
  const [helperText, setHelperText] = useState({
    bsp: "",
    sdr: "",
    gst: "",
    total: "",
  });
  const [openAlertConfimation, setOpenAlertConfimation] = useState(false);
  useEffect(() => {
    const priceObj = {
      bsp: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.bsp ? selectedAllotmentPass?.oldunitprice?.bsp : selectedAllotmentPass?.unitcost?.bsp) : selectedAllotmentPass?.oldunitprice?.bsp ? selectedAllotmentPass?.oldunitprice?.bsp : selectedAllotmentPass?.unitcost?.bsp,
      sdr: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.sdr ? selectedAllotmentPass?.oldunitprice?.sdr : selectedAllotmentPass?.unitcost?.sdr) : selectedAllotmentPass?.oldunitprice?.sdr ? selectedAllotmentPass?.oldunitprice?.sdr : selectedAllotmentPass?.unitcost?.sdr,
      gst: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.gst ? selectedAllotmentPass?.oldunitprice?.gst : selectedAllotmentPass?.unitcost?.gst) : selectedAllotmentPass?.oldunitprice?.gst ? selectedAllotmentPass?.oldunitprice?.gst : selectedAllotmentPass?.unitcost?.gst,
      total: selectedAllotmentPass?.oldunitprice ? (Number(selectedAllotmentPass?.oldunitprice?.bsp) + Number(selectedAllotmentPass?.oldunitprice?.sdr) + Number(selectedAllotmentPass?.oldunitprice?.gst)) : isRepriceForChangeUnit ? (Number(selectedAllotmentPass?.unitcost?.bsp) + Number(selectedAllotmentPass?.unitcost?.sdr) + Number(selectedAllotmentPass?.unitcost?.gst)) : Number(selectedAllotmentPass?.unitcost?.bsp) + Number(selectedAllotmentPass?.unitcost?.sdr) + Number(selectedAllotmentPass?.unitcost?.gst)
    }

    setUpdateUnitPrice(priceObj);
  }, []);

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  function update() {
    presentLoader();

    // ??check unit is available now

    checkForInventoryStatus(
      isRepriceForChangeUnit
        ? selectedAllotmentPass?.currentunitid
        : selectedAllotmentPass.unitid
    )
      .then((inventoryStatus) => {
        console.log({ inventoryStatus });
        if (inventoryStatus.data.inventoryStatusId.status === "Available") {
          updateInventorForCancelUnit(
            isRepriceForChangeUnit
              ? selectedAllotmentPass?.currentunitid
              : selectedAllotmentPass.unitid,
            updateUnitPrice.bsp,
            updateUnitPrice.gst,
            updateUnitPrice.sdr,
            updateUnitPrice.total,
          ).then((response) => {
            let InventoryLogObj = {
              userId: loggedInUser?.userId,
              leadId: selectedAllotmentPass.leadid,
              status: isRepriceForChangeUnit
                ? (skipChangesValues ? "Change Unit Price Skip" : "Change Unit Price Updated")
                : (skipChangesValues ? "Cancellation Price Skip" : "Cancellation Price Updated"),
              unitId: isRepriceForChangeUnit
                ? selectedAllotmentPass?.currentunitid
                : selectedAllotmentPass.unitid,
            };
            insertInventoryLogs(InventoryLogObj)
              .then((insertInventoryLogsRes) => {
                let updateCancelUnit = {
                  updatedUnitPrice: { ...updateUnitPrice },
                  unitPriceAlreadyUpdated: true,
                  last_updated_at: new Date().getTime(),
                };
                if (isRepriceForChangeUnit) {
                  updateChangeRequestsForReprice(
                    selectedAllotmentPass?.changeunitrequestid,
                    updateCancelUnit
                  )
                    .then((response) => {
                      returnRes(true);
                      dismissLoader();
                      handleClose();
                      successTost("Unit Price updated successfully");
                    })
                    .catch((err) => {
                      dismissLoader();
                      handleClose();
                      errorTost(err.message);
                      console.error("updateChangeRequestsForReprice", err);
                    });
                } else {
                  updateCancelRequestsForReprice(
                    selectedAllotmentPass?.cancelunitrequestid,
                    updateCancelUnit
                  )
                    .then((response) => {
                      returnRes(true);
                      dismissLoader();
                      handleClose();
                      successTost("Unit Price updated successfully");
                    })
                    .catch((err) => {
                      dismissLoader();
                      handleClose();
                      errorTost(err.message);
                      console.error("updateCancelRequestsForReprice", err);
                    });
                }
              })
              .catch((err) => {
                dismissLoader();
                handleClose();
                console.error("err while inserting into inventory log", err);
              });
          });
        } else {
          dismissLoader();
          handleClose();
          errorTost("This unit has been alloted now cannot update its price");
        }
      })
      .catch((err) => {
        dismissLoader();
        handleClose();
        console.error("checkForInventoryStatus", err);
      });

  }

  function closeModal() {
    handleClose();
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <div>{isRepricePending ? "Reprice Unit" : "Unit Cost Details"}</div>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
        </div>
        <div className={cssClasses.projectDataWrapper}>
          {(selectedAllotmentPass?.unitid ||
            selectedAllotmentPass?.currentunitid) && (
              <span>
                {
                  // selectedAllotmentPass?.allotmentPaymentId?.unitId?.wingId
                  //   ?.wingName
                  selectedAllotmentPass?.allotmentPaymentId?.unitId?.wingId
                    ?.displayName
                    ? selectedAllotmentPass?.allotmentPaymentId?.unitId?.wingId
                      ?.displayName
                    : isRepriceForChangeUnit
                      ? selectedAllotmentPass?.currentwingname
                      : selectedAllotmentPass?.wingname
                }{" "}
                -{" "}
                {isRepriceForChangeUnit
                  ? selectedAllotmentPass?.currentunitno
                  : selectedAllotmentPass?.unitno}{" "}
              </span>
            )}
          {selectedAllotmentPass?.inventorymergedid &&
            ((selectedAllotmentPass?.mergedwingid && (
              <span>
                {
                  // selectedAllotmentPass?.allotmentPaymentId
                  //   ?.inventoryMergedId.unit1Id.wingId
                  //   .wingName
                  selectedAllotmentPass?.allotmentPaymentId?.inventoryMergedId
                    .unit1Id.wingId.displayName
                    ? selectedAllotmentPass?.allotmentPaymentId
                      ?.inventoryMergedId.unit1Id.wingId.displayName
                    : selectedAllotmentPass?.mergedwing
                }{" "}
                - {selectedAllotmentPass?.unit1no} &{" "}
                {selectedAllotmentPass?.unit2no}{" "}
              </span>
            )) ||
              (!selectedAllotmentPass?.mergedwingid && (
                <span>
                  {
                    // selectedAllotmentPass?.allotmentPaymentId
                    //   ?.inventoryMergedId.unit1Id.wingId
                    //   .wingName
                    selectedAllotmentPass?.allotmentPaymentId?.inventoryMergedId
                      .unit1Id.wingId.displayName
                      ? selectedAllotmentPass?.allotmentPaymentId
                        ?.inventoryMergedId.unit1Id.wingId.displayName
                      : selectedAllotmentPass?.mergedwing
                  }{" "}
                  - {selectedAllotmentPass?.unit1no} &{" "}
                  {
                    // selectedAllotmentPass?.allotmentPaymentId
                    //   ?.inventoryMergedId.unit2Id.wingId
                    //   .wingName
                    selectedAllotmentPass?.allotmentPaymentId?.inventoryMergedId
                      .unit2Id.wingId.displayName
                      ? selectedAllotmentPass?.allotmentPaymentId
                        ?.inventoryMergedId.unit2Id.wingId.displayName
                      : selectedAllotmentPass?.mergedwing
                  }{" "}
                  - {selectedAllotmentPass?.unit2no}{" "}
                </span>
              )))}
          <span>|</span>
          {(selectedAllotmentPass?.unitid ||
            selectedAllotmentPass?.currentunitid) && (
              <span>
                {isRepriceForChangeUnit
                  ? selectedAllotmentPass?.currentprojectname
                  : selectedAllotmentPass?.projectname}
              </span>
            )}
          {selectedAllotmentPass?.inventorymergedid && (
            <span>{selectedAllotmentPass?.mergedproject}</span>
          )}
        </div>
        <div style={{ padding: "0 3rem 1rem 3rem", fontSize: "1.5rem" }}>
          {(selectedAllotmentPass?.inventorytypeid ||
            selectedAllotmentPass?.requestedunittype) && (
              <div style={{ display: "flex", gap: "1rem" }}>
                <span>Unit Type:</span>{" "}
                <span>
                  {isRepriceForChangeUnit
                    ? selectedAllotmentPass?.requestedunittype
                    : selectedAllotmentPass?.inventory_type}
                  {selectedAllotmentPass?.displayunittype
                    ? `(${selectedAllotmentPass?.displayunittype})`
                    : ""}
                </span>
              </div>
            )}
        </div>
        <div style={{ padding: "0 3rem 4rem 3rem", fontSize: "1.5rem" }}>
          {(selectedAllotmentPass?.unitid ||
            selectedAllotmentPass?.currentunitid) && (
              <div style={{ display: "flex", gap: "5rem" }}>
                <span>
                  Carpet Area(Sq.ft):{" "}
                  {selectedAllotmentPass?.chargeablearea
                    ? (
                      Number(selectedAllotmentPass?.chargeablearea) * 10.764
                    ).toFixed(2)
                    : "-"}
                </span>
                <span>
                  Saleable Area(Sq.ft):{" "}
                  {selectedAllotmentPass?.saleablearea
                    ? (
                      Number(selectedAllotmentPass?.saleablearea)
                    ).toFixed(2)
                    : "-"}
                </span>
              </div>
            )}
        </div>
        {isRepricePending && (
          <div className={cssClasses.wrapperContent}>
            <div className={cssClasses.wrapperBlock}>
              <CustomInput
                style={{ textTransform: "uppercase" }}
                value={updateUnitPrice?.bsp}
                label={"Agreement Value"}
                disabled={skipChangesValues}
                inputType={"number"}
                position={"start"}
                image={"true"}
                labelText={RupeeIcon}
                handleChange={(newValue) => {
                  if (!isNaN(newValue) && newValue !== "0") {
                    //  setUpdateUnitPrice((pre) => {
                    //    pre.bsp = Math.round(newValue);
                    //    pre.gst = Math.round(
                    //      Number(newValue) < 4500000
                    //        ? Number(newValue) / 100
                    //        : (Number(newValue) * 5) / 100
                    //    );
                    //    pre.sdr =
                    //      Math.ceil(
                    //        ((Number(newValue) *
                    //          (selectedAllotmentPass?.projectname ===
                    //            "YASHONE ETERNITEE PH-2" ||
                    //          selectedAllotmentPass?.requestedprojectname ===
                    //            "YASHONE ETERNITEE PH-2"
                    //            ? 6
                    //            : 7)) /
                    //          100 +
                    //          (Number(newValue) / 100 > 30000
                    //            ? 30000
                    //            : Number(newValue) / 100) +
                    //          15000) /
                    //          100
                    //      ) * 100;
                    //    pre.total = Math.round(
                    //      Number(newValue) +
                    //        (Number(newValue) < 4500000
                    //          ? Number(newValue) / 100
                    //          : (Number(newValue) * 5) / 100) +
                    //        Math.ceil(
                    //          ((Number(newValue) *
                    //            (selectedAllotmentPass?.projectname ===
                    //              "YASHONE ETERNITEE PH-2" ||
                    //            selectedAllotmentPass?.requestedprojectname ===
                    //              "YASHONE ETERNITEE PH-2"
                    //              ? 6
                    //              : 7)) /
                    //            100 +
                    //            (Number(newValue) / 100 > 30000
                    //              ? 30000
                    //              : Number(newValue) / 100) +
                    //            15000) /
                    //            100
                    //        ) *
                    //          100
                    //    );

                    //    return { ...pre };
                    //  });



                    setUpdateUnitPrice((pre) => {
                      pre.bsp = Math.round(newValue);

                      // ✅ Calculate GST % (commercial: from ProjectAdditionalConfiguration.gstPercentage,
                      // falling back to 12% if not yet configured; non-commercial: 1% if <45L, else 5%)
                      const gstPercent = selectedAllotmentPass?.isCommercial
                        ? Number(selectedAllotmentPass?.gstPercentage ?? 12)
                        : Number(newValue) < 4500000
                          ? 1
                          : 5;

                      pre.gst = Math.round((Number(newValue) * gstPercent) / 100);

                      // ✅ SDR calculation (unchanged)

                      console.log("enter in sdr=========");
                      console.log("selectedAllotmentPass?.sdrPercentage===",selectedAllotmentPass?.sdrPercentage);
                      console.log(" selectedAllotmentPass.legalCharges====", selectedAllotmentPass?.legalCharges);
                      
                      
                      
                      pre.sdr =
                        Math.ceil(
                        
                          ((Number(newValue) *
                            (selectedAllotmentPass?.sdrPercentage)) /
                            100 +
                            (Number(newValue) / 100 > 30000
                              ? 30000
                              : Number(newValue) / 100) +
                            selectedAllotmentPass?.legalCharges) /
                          100
                        ) * 100;

                      // ✅ Total calculation includes correct GST %
                      pre.total = Math.round(
                        Number(newValue) +
                        (Number(newValue) * gstPercent) / 100 +
                        Math.ceil(
                          ((Number(newValue) *
                            (selectedAllotmentPass?.sdrPercentage)) /
                            100 +
                            (Number(newValue) / 100 > 30000
                              ? 30000
                              : Number(newValue) / 100) +
                            selectedAllotmentPass?.legalCharges) /
                          100
                        ) *
                        100
                      );

                      return { ...pre };
                    });



                  }
                  if (
                    selectedAllotmentPass?.unitcost?.bsp === Number(newValue)
                  ) {
                    setUpdateUnitPrice((pre) => {
                      pre.bsp = selectedAllotmentPass?.unitcost?.bsp;
                      pre.gst = selectedAllotmentPass?.unitcost?.gst;
                      pre.sdr = selectedAllotmentPass?.unitcost?.sdr;
                      pre.total =
                        parseInt(selectedAllotmentPass?.unitcost?.bsp) +
                        parseInt(selectedAllotmentPass?.unitcost?.sdr) +
                        parseInt(selectedAllotmentPass?.unitcost?.gst);

                      return { ...pre };
                    });
                  }
                  if (newValue !== "" && newValue !== "0") {
                    setHelperText((pre) => {
                      pre.bsp = "";
                      return { ...pre };
                    });
                  } else {
                    setUpdateUnitPrice((pre) => {
                      pre.bsp = "";
                      pre.total = 0;
                      pre.sdr = 0;
                      pre.gst = 0;
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.bsp = "Please enter bsp";
                      return { ...pre };
                    });
                  }
                }}
                helperText={helperText.bsp}
              />
            </div>
            <div className={cssClasses.wrapperBlock}>
              {/* <CustomInput
               style={{ textTransform: "uppercase" }}
               value={updateUnitPrice?.gst}
               label={`GST (${
                 Number(updateUnitPrice?.bsp) < 4500000 ? "1%" : "5%"
               })`}
               inputType={"number"}
               position={"start"}
               disabled
               image={"true"}
               labelText={RupeeIcon}
               handleChange={(newValue) => {
                 setUpdateUnitPrice((pre) => {
                   pre.gst = newValue;
                   pre.total =
                     parseInt(newValue) +
                     parseInt(updateUnitPrice.bsp) +
                     parseInt(updateUnitPrice.sdr);
                   return { ...pre };
                 });
                 if (newValue !== "") {
                   setHelperText((pre) => {
                     pre.gst = "";
                     return { ...pre };
                   });
                 } else {
                   setUpdateUnitPrice((pre) => {
                     pre.total =
                       parseInt(updateUnitPrice.bsp) +
                       parseInt(updateUnitPrice.sdr);
                     return { ...pre };
                   });
                   setHelperText((pre) => {
                     pre.gst = "Please enter gst";
                     return { ...pre };
                   });
                 }
               }}
               helperText={helperText.gst}
             /> */}

              <CustomInput
                style={{ textTransform: "uppercase" }}
                value={updateUnitPrice?.gst}
                label={`GST (${selectedAllotmentPass?.isCommercial
                    ? `${Number(selectedAllotmentPass?.gstPercentage ?? 12)}%`
                    : Number(updateUnitPrice?.bsp) < 4500000
                      ? "1%"
                      : "5%"
                  })`}
                inputType={"number"}
                position={"start"}
                disabled
                image={"true"}
                labelText={RupeeIcon}
                handleChange={(newValue) => {
                  const gstPercentage = selectedAllotmentPass?.isCommercial
                    ? Number(selectedAllotmentPass?.gstPercentage ?? 12)
                    : Number(updateUnitPrice?.bsp) < 4500000
                      ? 1
                      : 5;

                  setUpdateUnitPrice((pre) => {
                    pre.gst = newValue;
                    pre.total =
                      parseInt(updateUnitPrice.bsp) +
                      parseInt(updateUnitPrice.sdr) +
                      parseInt(newValue);
                    return { ...pre };
                  });

                  if (newValue !== "") {
                    setHelperText((pre) => {
                      pre.gst = "";
                      return { ...pre };
                    });
                  } else {
                    setUpdateUnitPrice((pre) => {
                      pre.total =
                        parseInt(updateUnitPrice.bsp) + parseInt(updateUnitPrice.sdr);
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.gst = "Please enter gst";
                      return { ...pre };
                    });
                  }

                  console.log("isCommercial", selectedAllotmentPass?.isCommercial);
                  console.log("GST Percentage Applied:", gstPercentage);
                }}
                helperText={helperText.gst}
              />

            </div>
            <div className={cssClasses.wrapperBlock}>
              <CustomInput
                style={{ textTransform: "uppercase" }}
                value={updateUnitPrice?.sdr}
                label={"SDR(7%) + Fee"}
                position={"start"}
                image={"true"}
                disabled
                labelText={RupeeIcon}
                handleChange={(newValue) => {
                  setUpdateUnitPrice((pre) => {
                    pre.sdr = newValue;
                    pre.total =
                      parseInt(newValue) +
                      parseInt(updateUnitPrice.gst) +
                      parseInt(updateUnitPrice.bsp);
                    return { ...pre };
                  });
                  if (newValue === "") {
                    setUpdateUnitPrice((pre) => {
                      pre.sdr = newValue;
                      pre.total =
                        parseInt(updateUnitPrice.gst) +
                        parseInt(updateUnitPrice.bsp);
                      return { ...pre };
                    });
                    setHelperText((pre) => {
                      pre.sdr = "Please enter sdr";
                      return { ...pre };
                    });
                  } else {
                    setHelperText((pre) => {
                      pre.sdr = "";
                      return { ...pre };
                    });
                  }
                }}
                inputType={"number"}
                helperText={helperText.sdr}
              />
            </div>

            <div className={cssClasses.wrapperBlock}>
              <CustomInput
                style={{ textTransform: "uppercase" }}
                value={updateUnitPrice?.total}
                label={"Total"}
                disabled
                inputType={"number"}
                position={"start"}
                image={"true"}
                labelText={RupeeIcon}
                handleChange={(newValue) => {
                  // setUpdateUnitPrice((pre)=>{
                  //   pre.total=newValue;
                  //   return {...pre}
                  // });
                }}
                helperText={helperText.total}
              />
            </div>
          </div>
        )}

        {isRepricePending && (
          <div style={{ display: "flex", alignItems: "center", padding: "0 2rem" }}>
            <Checkbox
              sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
              checked={skipChangesValues}
              onChange={(e) => {
                setSkipChangesValues(e.target.checked);

                const priceObj = {
                  bsp: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.bsp ? selectedAllotmentPass?.oldunitprice?.bsp : selectedAllotmentPass?.unitcost?.bsp) : selectedAllotmentPass?.oldunitprice?.bsp ? selectedAllotmentPass?.oldunitprice?.bsp : selectedAllotmentPass?.unitcost?.bsp,
                  sdr: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.sdr ? selectedAllotmentPass?.oldunitprice?.sdr : selectedAllotmentPass?.unitcost?.sdr) : selectedAllotmentPass?.oldunitprice?.sdr ? selectedAllotmentPass?.oldunitprice?.sdr : selectedAllotmentPass?.unitcost?.sdr,
                  gst: isRepriceForChangeUnit ? (selectedAllotmentPass?.oldunitprice?.gst ? selectedAllotmentPass?.oldunitprice?.gst : selectedAllotmentPass?.unitcost?.gst) : selectedAllotmentPass?.oldunitprice?.gst ? selectedAllotmentPass?.oldunitprice?.gst : selectedAllotmentPass?.unitcost?.gst,
                  total: selectedAllotmentPass?.oldunitprice ? (Number(selectedAllotmentPass?.oldunitprice?.bsp) + Number(selectedAllotmentPass?.oldunitprice?.sdr) + Number(selectedAllotmentPass?.oldunitprice?.gst)) : isRepriceForChangeUnit ? (Number(selectedAllotmentPass?.unitcost?.bsp) + Number(selectedAllotmentPass?.unitcost?.sdr) + Number(selectedAllotmentPass?.unitcost?.gst)) : Number(selectedAllotmentPass?.unitcost?.bsp) + Number(selectedAllotmentPass?.unitcost?.sdr) + Number(selectedAllotmentPass?.unitcost?.gst)
                }

                setUpdateUnitPrice(priceObj);
              }}
            />
            <Typography
              ml={"1rem"}
              mb={"0"}
              sx={[
                {
                  textAlign: "center",
                  marginBottom: "0",
                  fontSize: "1.6rem",
                  fontFamily: "inter-Medium"
                },
              ]}
            >
              Skip changes
            </Typography>
          </div>
        )}

        {selectedAllotmentPass?.unitpricealreadyupdated && (
          <div className={cssClasses?.unitCostWrapper}>
            <div className={cssClasses?.unitPriceWrapper}>
              <span style={{ fontFamily: "Inter-SemiBold", fontSize: "1.6rem" }}>
                Old Unit Cost
              </span>
              <span>
                Agreement Value :{" "}
                {selectedAllotmentPass?.oldunitprice?.bsp
                  ? numberWithCommas(selectedAllotmentPass?.oldunitprice?.bsp)
                  : selectedAllotmentPass?.unitcost?.bsp
                    ? numberWithCommas(selectedAllotmentPass?.unitcost?.bsp)
                    : "-"}
              </span>
              <span>
                GST :{" "}
                {selectedAllotmentPass?.oldunitprice?.gst
                  ? numberWithCommas(selectedAllotmentPass?.oldunitprice?.gst)
                  : selectedAllotmentPass?.unitcost?.gst
                    ? numberWithCommas(selectedAllotmentPass?.unitcost?.gst)
                    : "-"}
              </span>
              <span>
                SDR :{" "}
                {selectedAllotmentPass?.oldunitprice?.sdr
                  ? numberWithCommas(selectedAllotmentPass?.oldunitprice?.sdr)
                  : selectedAllotmentPass.unitcost?.sdr
                    ? numberWithCommas(selectedAllotmentPass?.unitcost?.sdr)
                    : "-"}
              </span>
              <span>
                Total :{" "}
                {selectedAllotmentPass?.oldunitprice?.total
                  ? numberWithCommas(selectedAllotmentPass?.oldunitprice?.total)
                  : selectedAllotmentPass?.unitcost?.total
                    ? numberWithCommas(selectedAllotmentPass?.unitcost?.total)
                    : "-"}
              </span>
            </div>
            <div className={cssClasses?.unitPriceWrapper}>
              <span style={{ fontFamily: "Inter-SemiBold", fontSize: "1.6rem" }}>
                Updated Unit Cost
              </span>
              <span>
                Agreement Value :{" "}
                {isRepriceForChangeUnit
                  ? numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.bsp
                  )
                  : numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.bsp
                  )}
              </span>
              <span>
                GST :{" "}
                {isRepriceForChangeUnit
                  ? numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.gst
                  )
                  : numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.gst
                  )}
              </span>
              <span>
                SDR :{" "}
                {isRepriceForChangeUnit
                  ? numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.sdr
                  )
                  : numberWithCommas(
                    selectedAllotmentPass?.updatedunitprice?.sdr
                  )}
              </span>
              <span>
                Total :{" "}
                {isRepriceForChangeUnit
                  ? numberWithCommas(
                    Number(selectedAllotmentPass?.updatedunitprice?.bsp) +
                    Number(selectedAllotmentPass?.updatedunitprice?.sdr) +
                    Number(selectedAllotmentPass?.updatedunitprice?.gst)
                  )
                  : numberWithCommas(
                    Number(selectedAllotmentPass?.updatedunitprice?.bsp) +
                    Number(selectedAllotmentPass?.updatedunitprice?.sdr) +
                    Number(selectedAllotmentPass?.updatedunitprice?.gst)
                  )}
              </span>
            </div>
          </div>
        )}
        {isRepricePending && (
          <div className={cssClasses.wrapperFooter}>
            <div>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Cancel"}
                clicked={closeModal}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                disable={
                  skipChangesValues ? false : (helperText.bsp !== "" ||
                    helperText.gst !== "" ||
                    helperText.sdr !== "" ||
                    selectedAllotmentPass?.unitcost?.bsp === updateUnitPrice?.bsp)
                }
                btnName={"Update"}
                clicked={() => {
                  // update();
                  setOpenAlertConfimation(true);
                }}
              />
            </div>
          </div>
        )}
        <ConfirmationAlert
          hideCloseIcon={true}
          confirm={(e) => {
            console.log(e);
            if (e === "confirmed") {
              update();
            } else if ("rejected") {
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setOpenAlertConfimation(false)}
          title={"Info"}
          subTitle={`Do you want to update unit price?`}
          open={openAlertConfimation}
        />
      </Box>
    </Modal>
  );
}